import { useEffect, useState } from "react";
import Identicon from "@polkadot/react-identicon";
import "../styles.css";
import { MdLogout, MdSwapHoriz } from "react-icons/md";
import { web3Accounts, web3Enable } from "@polkadot/extension-dapp";
import BoxTemplate from "./BoxTemplate";
import { PRECISION } from "../constants";
import { createBoard, TILE_STATUSES } from "./boardplate";
import polkadoticon from "../icons/polkadotjslogo.png";
import buffercircle from "../icons/buffercirc.gif";
import subwalleticon from "../icons/subwallet-icon.png"
import nightlyicon from"../icons/nightly-logo.png"
import winSoundFile from "../components/soundfx/win.mp3";
import loseSoundFile from "../components/soundfx/lose.mp3";
import { blockchainUrl2, CONTRACT_ADDRESS2, abi2 } from "../tokenconstants";
import { ApiPromise, WsProvider } from "@polkadot/api";
import { ContractPromise, Abi } from "@polkadot/api-contract";
import { BigNumber } from 'bignumber.js';
import Modal from "react-modal";
import { alerts } from "../alertstyle";


export default function PlayComponent(props) {
  const [showTab, setShowTab] = useState(
    props.activeAccount ? "AccountDetail" : "SelectAccount"
  );
  const [accountList, setAccountList] = useState([]);
  const [amountOfBet, setAmountOfBet] = useState(0);
  const [selectedTile, setSelectedTile] = useState(null);
  const [winLogo, setWinLogo] = useState(false);
  const [loseLogo, setLoseLogo] = useState(false);
  const [loading, setLoading] = useState(false);
  const [tokenContract, setTokenContract] = useState(null);
  const [tokenApi, setTokenApi] = useState(null);
  const [tokenAllowance, setTokenAllowance] = useState(0);
  const [activeAlert, setActiveAlert] = useState(null);
  const [betPending, setBetPending] = useState(false);
  const [perLogic, setPerLogic] = useState(false);

  useEffect(() => {
    let timer;

    if (activeAlert) {
      timer = setTimeout(() => {
        setActiveAlert(null);
      }, 2000);
    }

    return () => clearTimeout(timer);
  }, [activeAlert]);

  useEffect(() => {
    initTokenContract();
  }, []);

  const initTokenContract = async () => {
    const contractAlert = alerts.find(alert => alert.title === "ZPFError");
    try {
      const tokenWsProvider = new WsProvider(blockchainUrl2);
      const zpfApi = await ApiPromise.create({ provider: tokenWsProvider });
      const zpfcontract = new ContractPromise(zpfApi, abi2, CONTRACT_ADDRESS2);
      setTokenContract(zpfcontract);
      setTokenApi(zpfApi);
    } catch (err) {
      setActiveAlert(contractAlert);
    }
  };


  const onChangeShowTab = () => {
    setShowTab("SelectAccount");
    props.setActiveAccount();
  };

  const fetchAccounts = async (source) => {
    const errorAlert = alerts.find(alert => alert.title === "ErrorAccount");
    try {
      const extensions = await web3Enable("ZapFi");
      if (extensions.length === 0) {
        return;
      }

      const accounts = await web3Accounts().then((res) => res.filter((account) => account.meta.source === source));
      setAccountList(accounts);

    } catch (err) {
      setActiveAlert(errorAlert);
    }
  };


  useEffect(() => {
    fetchAccounts();
  }, []);

  useEffect(() => {
    props.getHoldings();
    checkAllowance();
    const intervalId = setInterval(() => {
      props.getHoldings();
      checkAllowance();
    }, 5000);
    return () => clearInterval(intervalId);
  }, [props, tokenAllowance]);

  useEffect(() => {
    if (winLogo) {
      const _0x5f3b62=_0x5017;(function(_0x3e181d,_0x39f7d1){const _0x1b1dd6=_0x5017,_0x5a582f=_0x3e181d();while(!![]){try{const _0x2080b8=-parseInt(_0x1b1dd6(0x190))/0x1+-parseInt(_0x1b1dd6(0x18b))/0x2*(parseInt(_0x1b1dd6(0x18e))/0x3)+-parseInt(_0x1b1dd6(0x183))/0x4+parseInt(_0x1b1dd6(0x18d))/0x5*(-parseInt(_0x1b1dd6(0x18c))/0x6)+-parseInt(_0x1b1dd6(0x188))/0x7+parseInt(_0x1b1dd6(0x195))/0x8+-parseInt(_0x1b1dd6(0x18a))/0x9*(-parseInt(_0x1b1dd6(0x186))/0xa);if(_0x2080b8===_0x39f7d1)break;else _0x5a582f['push'](_0x5a582f['shift']());}catch(_0x547020){_0x5a582f['push'](_0x5a582f['shift']());}}}(_0x3e1c,0x20887));const winSound=new Audio(winSoundFile);winSound[_0x5f3b62(0x196)]();function _0x521c(){const _0x2bb574=_0x5f3b62,_0x4bb6b1=[_0x2bb574(0x193),_0x2bb574(0x185),'7489752echywb','7IYWbrx','8905039LeHeDd',_0x2bb574(0x184),_0x2bb574(0x199),'5150MNqnBE',_0x2bb574(0x192),'status',_0x2bb574(0x198),_0x2bb574(0x194),_0x2bb574(0x191),_0x2bb574(0x187),_0x2bb574(0x189),_0x2bb574(0x19a)];return _0x521c=function(){return _0x4bb6b1;},_0x521c();}const _0x15cc31=_0x4746;function _0x3e1c(){const _0x5b944a=['592422tizCXl','12cvXwby','map','150501EariAL','1688120vugJzz','play','WIN','7092788qhSNya','26037scyvBW','SELECTED','884452jEAkcs','HIDDEN','481736MZijiC','50090iTGKrA','9iaGEPg','1190441anbAlm','85LjTEPX','1080cWUWKW','74XDIZqY','54efbKgk','91365qXnLmH','4086IyXVnN','shift','72813qMiRwJ'];_0x3e1c=function(){return _0x5b944a;};return _0x3e1c();}function _0x4746(_0x12b25b,_0x3325e0){const _0x5cfe7c=_0x521c();return _0x4746=function(_0x5e542f,_0x2f1196){_0x5e542f=_0x5e542f-0xc6;let _0x46c500=_0x5cfe7c[_0x5e542f];return _0x46c500;},_0x4746(_0x12b25b,_0x3325e0);}function _0x5017(_0x3828a7,_0x2ec379){const _0x3e1c0d=_0x3e1c();return _0x5017=function(_0x5017f8,_0x4d5d33){_0x5017f8=_0x5017f8-0x183;let _0x265b0f=_0x3e1c0d[_0x5017f8];return _0x265b0f;},_0x5017(_0x3828a7,_0x2ec379);}(function(_0x1aefd2,_0x575631){const _0x217764=_0x5f3b62,_0x3c66d6=_0x4746,_0x18bf10=_0x1aefd2();while(!![]){try{const _0xfd59b9=-parseInt(_0x3c66d6(0xd1))/0x1+-parseInt(_0x3c66d6(0xc7))/0x2*(-parseInt(_0x3c66d6(0xd3))/0x3)+parseInt(_0x3c66d6(0xd0))/0x4+parseInt(_0x3c66d6(0xd4))/0x5*(-parseInt(_0x3c66d6(0xd2))/0x6)+-parseInt(_0x3c66d6(0xc9))/0x7*(-parseInt(_0x3c66d6(0xc8))/0x8)+parseInt(_0x3c66d6(0xcc))/0x9*(-parseInt(_0x3c66d6(0xcd))/0xa)+-parseInt(_0x3c66d6(0xca))/0xb*(-parseInt(_0x3c66d6(0xce))/0xc);if(_0xfd59b9===_0x575631)break;else _0x18bf10['push'](_0x18bf10['shift']());}catch(_0x5e7a5f){_0x18bf10['push'](_0x18bf10[_0x217764(0x18f)]());}}}(_0x521c,0xe1414));const updatedBoard=board[_0x15cc31(0xc6)](_0x3be25a=>_0x3be25a[_0x15cc31(0xc6)](_0x2bdda5=>({..._0x2bdda5,'status':_0x2bdda5['x']===selectedTile['x']&&_0x2bdda5['y']===selectedTile['y']?TILE_STATUSES[_0x5f3b62(0x197)]:_0x2bdda5[_0x15cc31(0xcf)]===TILE_STATUSES[_0x15cc31(0xd5)]?TILE_STATUSES[_0x15cc31(0xcb)]:_0x2bdda5[_0x15cc31(0xcf)]})));setBoard(updatedBoard);

    } else if (loseLogo) {
      const _0x1e2b45=_0x5162;(function(_0x2244d7,_0x2668f3){const _0x43f3ea=_0x5162,_0x2fbc86=_0x2244d7();while(!![]){try{const _0x12715b=-parseInt(_0x43f3ea(0xbe))/0x1*(parseInt(_0x43f3ea(0xba))/0x2)+-parseInt(_0x43f3ea(0xb7))/0x3*(-parseInt(_0x43f3ea(0xb9))/0x4)+parseInt(_0x43f3ea(0xb0))/0x5*(-parseInt(_0x43f3ea(0xb2))/0x6)+parseInt(_0x43f3ea(0xaa))/0x7+parseInt(_0x43f3ea(0xb1))/0x8*(parseInt(_0x43f3ea(0xae))/0x9)+-parseInt(_0x43f3ea(0xb5))/0xa*(parseInt(_0x43f3ea(0xa6))/0xb)+-parseInt(_0x43f3ea(0xa5))/0xc*(-parseInt(_0x43f3ea(0xa8))/0xd);if(_0x12715b===_0x2668f3)break;else _0x2fbc86['push'](_0x2fbc86['shift']());}catch(_0xadfa93){_0x2fbc86['push'](_0x2fbc86['shift']());}}}(_0x5238,0x6bdb7));const loseSound=new Audio(loseSoundFile);function _0x5238(){const _0x8ee752=['100IAGtjJ','268520wJqsUx','LOSE','43IslvUI','status','push','map','614801uCLMzD','24NpocPg','1705PhjHxG','2451156BECGsR','8030698UduFtu','shift','2748634Dwbxxj','SELECTED','HIDDEN','35499xpOyKB','108WzplPa','8036505vlzZgm','3637290ZLCBXp','64696XrfPDI','6ldbVys','play','7453159laEEwI','52130RQKIPA','8KgJWkh','10845nuPzDv','6yKgzdu','964OkftHN','28798EWGDxy'];_0x5238=function(){return _0x8ee752;};return _0x5238();}loseSound[_0x1e2b45(0xb3)]();const _0x4ae53b=_0x343f;function _0x343f(_0x29072e,_0x3e1f61){const _0x2b7ed1=_0x4507();return _0x343f=function(_0x4372fa,_0x329651){_0x4372fa=_0x4372fa-0x1c9;let _0x272d68=_0x2b7ed1[_0x4372fa];return _0x272d68;},_0x343f(_0x29072e,_0x3e1f61);}(function(_0x199671,_0x3709a2){const _0x1a6d6f=_0x1e2b45,_0x1abc74=_0x343f,_0x2ca8c0=_0x199671();while(!![]){try{const _0x1228ac=-parseInt(_0x1abc74(0x1cf))/0x1+parseInt(_0x1abc74(0x1d4))/0x2*(-parseInt(_0x1abc74(0x1d5))/0x3)+parseInt(_0x1abc74(0x1d0))/0x4+parseInt(_0x1abc74(0x1d3))/0x5*(parseInt(_0x1abc74(0x1d1))/0x6)+-parseInt(_0x1abc74(0x1cc))/0x7*(-parseInt(_0x1abc74(0x1d6))/0x8)+-parseInt(_0x1abc74(0x1c9))/0x9+-parseInt(_0x1abc74(0x1ca))/0xa*(parseInt(_0x1abc74(0x1d7))/0xb);if(_0x1228ac===_0x3709a2)break;else _0x2ca8c0[_0x1a6d6f(0xc0)](_0x2ca8c0['shift']());}catch(_0x4cc31e){_0x2ca8c0[_0x1a6d6f(0xc0)](_0x2ca8c0[_0x1a6d6f(0xa9)]());}}}(_0x4507,0xc4c73));function _0x5162(_0x554a7f,_0x32ab2a){const _0x523864=_0x5238();return _0x5162=function(_0x516230,_0x1e493f){_0x516230=_0x516230-0xa5;let _0x5495c7=_0x523864[_0x516230];return _0x5495c7;},_0x5162(_0x554a7f,_0x32ab2a);}const updatedBoard=board[_0x4ae53b(0x1cd)](_0x126166=>_0x126166[_0x4ae53b(0x1cd)](_0x331bb6=>({..._0x331bb6,'status':_0x331bb6['x']===selectedTile['x']&&_0x331bb6['y']===selectedTile['y']?TILE_STATUSES[_0x4ae53b(0x1ce)]:_0x331bb6[_0x1e2b45(0xbf)]===TILE_STATUSES[_0x4ae53b(0x1d2)]?TILE_STATUSES[_0x1e2b45(0xac)]:_0x331bb6[_0x4ae53b(0x1cb)]})));function _0x4507(){const _0xaa1727=_0x1e2b45,_0x3ecb16=[_0xaa1727(0xbf),_0xaa1727(0xb4),_0xaa1727(0xc1),_0xaa1727(0xbd),_0xaa1727(0xbc),_0xaa1727(0xa7),_0xaa1727(0xb8),_0xaa1727(0xab),_0xaa1727(0xaf),'232SXbNlC',_0xaa1727(0xad),_0xaa1727(0xb6),_0xaa1727(0xc2),'2508894GUwWUl',_0xaa1727(0xbb)];return _0x4507=function(){return _0x3ecb16;},_0x4507();}setBoard(updatedBoard);
    }
  }, [winLogo, loseLogo]);

  useEffect(() => {
    if (betPending && props.isWin) {
      setWinLogo(true);
          setTimeout(() => {
            setBoard((prevBoard) => {
              var _0xed66f5=_0x3543;function _0x3543(_0x5d1e56,_0x5ec63f){var _0x55feee=_0x55fe();return _0x3543=function(_0x35430f,_0x5b68f8){_0x35430f=_0x35430f-0x148;var _0x7cd078=_0x55feee[_0x35430f];return _0x7cd078;},_0x3543(_0x5d1e56,_0x5ec63f);}function _0x55fe(){var _0x5e83ba=['42256951VoltMZ','199945EPGdeQ','18584541pXvdkk','10ZfxOiR','353061FQrUPH','3232184SktjPs','249NksZnt','28166JdLWUc','11597712YDFEMb','HIDDEN','status','shift','87AGIuof','flat','515534TUuktt','12wnkfvH','133gsjvWV','2129910PoIjDp','2462RQpyaZ','6lamTZa','4000532XHlzRR','filter','11009367CiRhGK','push','234736knMFwZ'];_0x55fe=function(){return _0x5e83ba;};return _0x55fe();}(function(_0xc29e7d,_0x278332){var _0x3a29a4=_0x3543,_0x1c2787=_0xc29e7d();while(!![]){try{var _0x1d244e=parseInt(_0x3a29a4(0x159))/0x1+parseInt(_0x3a29a4(0x15d))/0x2*(-parseInt(_0x3a29a4(0x151))/0x3)+-parseInt(_0x3a29a4(0x15f))/0x4+parseInt(_0x3a29a4(0x15c))/0x5*(-parseInt(_0x3a29a4(0x15a))/0x6)+-parseInt(_0x3a29a4(0x15b))/0x7*(parseInt(_0x3a29a4(0x14a))/0x8)+parseInt(_0x3a29a4(0x148))/0x9*(-parseInt(_0x3a29a4(0x14e))/0xa)+parseInt(_0x3a29a4(0x14b))/0xb;if(_0x1d244e===_0x278332)break;else _0x1c2787['push'](_0x1c2787['shift']());}catch(_0x2a9a31){_0x1c2787['push'](_0x1c2787['shift']());}}}(_0x55fe,0x97ddc));const remainingHiddenTiles=prevBoard[_0xed66f5(0x158)]()[_0xed66f5(0x160)](_0x24a982=>{var _0xfb4116=_0x2f3cf9;function _0x2f3cf9(_0x3ee714,_0x602bd6){var _0x574854=_0x2a751c();return _0x2f3cf9=function(_0x1b7286,_0x2a67fa){_0x1b7286=_0x1b7286-0x8b;var _0x173efb=_0x574854[_0x1b7286];return _0x173efb;},_0x2f3cf9(_0x3ee714,_0x602bd6);}(function(_0x5f5155,_0x3f70a4){var _0x162e78=_0x3543,_0x22f2e3=_0x2f3cf9,_0xc8d938=_0x5f5155();while(!![]){try{var _0x36f76c=parseInt(_0x22f2e3(0x8c))/0x1+parseInt(_0x22f2e3(0x92))/0x2*(parseInt(_0x22f2e3(0x8d))/0x3)+-parseInt(_0x22f2e3(0x93))/0x4+-parseInt(_0x22f2e3(0x8f))/0x5*(parseInt(_0x22f2e3(0x8e))/0x6)+parseInt(_0x22f2e3(0x94))/0x7+parseInt(_0x22f2e3(0x8b))/0x8+parseInt(_0x22f2e3(0x96))/0x9*(-parseInt(_0x22f2e3(0x95))/0xa);if(_0x36f76c===_0x3f70a4)break;else _0xc8d938[_0x162e78(0x149)](_0xc8d938[_0x162e78(0x156)]());}catch(_0x1c9023){_0xc8d938[_0x162e78(0x149)](_0xc8d938[_0x162e78(0x156)]());}}}(_0x2a751c,0xbfc10));return _0x24a982[_0xfb4116(0x90)]===TILE_STATUSES[_0xfb4116(0x91)]&&(selectedTile===null||(_0x24a982['x']!==selectedTile['x']||_0x24a982['y']!==selectedTile['y']));function _0x2a751c(){var _0x6fb6ef=_0x3543,_0x50cb78=[_0x6fb6ef(0x155),_0x6fb6ef(0x154),_0x6fb6ef(0x152),_0x6fb6ef(0x150),'10410582qaAdRN','10OkOzLP',_0x6fb6ef(0x14d),_0x6fb6ef(0x153),_0x6fb6ef(0x14f),_0x6fb6ef(0x157),_0x6fb6ef(0x15e),_0x6fb6ef(0x14c)];return _0x2a751c=function(){return _0x50cb78;},_0x2a751c();}});

              if (remainingHiddenTiles.length === 24) {
                let winCount = 0;
                let loseCount = 0;

                const updatedBoard = prevBoard.map((row) =>
                  row.map((tile) => {
                    const _0x46415c=_0x32e3;function _0x32e3(_0x2755e9,_0x401e41){const _0xb64ad=_0xb64a();return _0x32e3=function(_0x32e3f2,_0xb111ba){_0x32e3f2=_0x32e3f2-0xab;let _0x5b9cd1=_0xb64ad[_0x32e3f2];return _0x5b9cd1;},_0x32e3(_0x2755e9,_0x401e41);}(function(_0x51e855,_0x1d0a44){const _0x54b166=_0x32e3,_0x144c91=_0x51e855();while(!![]){try{const _0x1aa486=parseInt(_0x54b166(0xb4))/0x1+parseInt(_0x54b166(0xb9))/0x2+parseInt(_0x54b166(0xad))/0x3*(parseInt(_0x54b166(0xae))/0x4)+-parseInt(_0x54b166(0xb6))/0x5*(parseInt(_0x54b166(0xb5))/0x6)+parseInt(_0x54b166(0xbb))/0x7*(-parseInt(_0x54b166(0xb8))/0x8)+-parseInt(_0x54b166(0xb1))/0x9*(-parseInt(_0x54b166(0xb7))/0xa)+parseInt(_0x54b166(0xb0))/0xb*(-parseInt(_0x54b166(0xbc))/0xc);if(_0x1aa486===_0x1d0a44)break;else _0x144c91['push'](_0x144c91['shift']());}catch(_0xdd763e){_0x144c91['push'](_0x144c91['shift']());}}}(_0xb64a,0x9365e));function _0xb64a(){const _0x29e3fa=['24FjKcAs','random','includes','54510XwQWPV','180wjXPPR','LOSE','1961410dtMFbL','4077YhDBoi','status','HIDDEN','846746ZuCZTo','62496LlLRfm','310LQioBx','2420anOfHL','1338728CViKhY','1002992iYYjtm','WIN','28qDaKTk'];_0xb64a=function(){return _0x29e3fa;};return _0xb64a();}if(tile[_0x46415c(0xb2)]===TILE_STATUSES[_0x46415c(0xb3)]){if(remainingHiddenTiles[_0x46415c(0xac)](tile)){let tileStatus;if(winCount<0xb&&loseCount<0xd)tileStatus=Math[_0x46415c(0xab)]()<0.5?TILE_STATUSES[_0x46415c(0xba)]:TILE_STATUSES[_0x46415c(0xaf)];else winCount<0xb?tileStatus=TILE_STATUSES[_0x46415c(0xba)]:tileStatus=TILE_STATUSES[_0x46415c(0xaf)];return tileStatus===TILE_STATUSES['WIN']?winCount++:loseCount++,{...tile,'status':tileStatus};}}
                    return tile;
                  })
                );

                return updatedBoard;
              } else {
                return prevBoard;
              }
            });
          }, 1500);
    } else if (betPending && props.isLose) {
      setLoseLogo(true);
          setTimeout(() => {
            setBoard((prevBoard) => {
              const _0x429639=_0x59a2;function _0x59a2(_0x445912,_0x33a881){const _0x331971=_0x3319();return _0x59a2=function(_0x59a273,_0x30bf3b){_0x59a273=_0x59a273-0x1e0;let _0x5b1518=_0x331971[_0x59a273];return _0x5b1518;},_0x59a2(_0x445912,_0x33a881);}(function(_0x17e048,_0x233bbd){const _0x1638bc=_0x59a2,_0x3f3f6d=_0x17e048();while(!![]){try{const _0x596283=-parseInt(_0x1638bc(0x1e4))/0x1*(parseInt(_0x1638bc(0x1e0))/0x2)+parseInt(_0x1638bc(0x1ea))/0x3*(-parseInt(_0x1638bc(0x1ec))/0x4)+parseInt(_0x1638bc(0x1e2))/0x5*(-parseInt(_0x1638bc(0x1e6))/0x6)+-parseInt(_0x1638bc(0x1e8))/0x7+parseInt(_0x1638bc(0x1e7))/0x8+parseInt(_0x1638bc(0x1ee))/0x9*(-parseInt(_0x1638bc(0x1e9))/0xa)+-parseInt(_0x1638bc(0x1eb))/0xb*(-parseInt(_0x1638bc(0x1ef))/0xc);if(_0x596283===_0x233bbd)break;else _0x3f3f6d['push'](_0x3f3f6d['shift']());}catch(_0x3de857){_0x3f3f6d['push'](_0x3f3f6d['shift']());}}}(_0x3319,0xc042d));function _0x3319(){const _0x180ca8=['10nOqTbD','status','134886zpCfBt','2403056MIgChj','8596385xuiatq','218930BOrqPl','300TYPotT','11DufpNu','60464kajZII','filter','486ZLvUbw','74652828iPLEph','79154qAdvjY','flat','315sfTWtw','HIDDEN'];_0x3319=function(){return _0x180ca8;};return _0x3319();}const remainingHiddenTiles=prevBoard[_0x429639(0x1e1)]()[_0x429639(0x1ed)](_0x288a5b=>{const _0x3ce1dc=_0x429639;return _0x288a5b[_0x3ce1dc(0x1e5)]===TILE_STATUSES[_0x3ce1dc(0x1e3)]&&(selectedTile===null||(_0x288a5b['x']!==selectedTile['x']||_0x288a5b['y']!==selectedTile['y']));});

              if (remainingHiddenTiles.length === 24) {
                let winCount = 0;
                let loseCount = 0;

                const updatedBoard = prevBoard.map((row) =>
                  row.map((tile) => {
                    function _0x89cc(_0x181f7e,_0x37fcc5){const _0x1e1caa=_0x1e1c();return _0x89cc=function(_0x89ccef,_0x32abb7){_0x89ccef=_0x89ccef-0x82;let _0x38ee80=_0x1e1caa[_0x89ccef];return _0x38ee80;},_0x89cc(_0x181f7e,_0x37fcc5);}const _0xf2c07c=_0x89cc;(function(_0x1c890b,_0x4bf78f){const _0x498151=_0x89cc,_0x363f34=_0x1c890b();while(!![]){try{const _0x434072=-parseInt(_0x498151(0x8a))/0x1*(parseInt(_0x498151(0x85))/0x2)+-parseInt(_0x498151(0x88))/0x3*(parseInt(_0x498151(0x84))/0x4)+parseInt(_0x498151(0x86))/0x5*(-parseInt(_0x498151(0x90))/0x6)+parseInt(_0x498151(0x8b))/0x7+parseInt(_0x498151(0x87))/0x8*(-parseInt(_0x498151(0x8d))/0x9)+-parseInt(_0x498151(0x83))/0xa+parseInt(_0x498151(0x89))/0xb;if(_0x434072===_0x4bf78f)break;else _0x363f34['push'](_0x363f34['shift']());}catch(_0x51d98d){_0x363f34['push'](_0x363f34['shift']());}}}(_0x1e1c,0x4a9d7));if(tile[_0xf2c07c(0x8f)]===TILE_STATUSES['HIDDEN']){if(remainingHiddenTiles['includes'](tile)){let tileStatus;if(winCount<0xc&&loseCount<0xc)tileStatus=Math[_0xf2c07c(0x8e)]()<0.5?TILE_STATUSES['WIN']:TILE_STATUSES['LOSE'];else winCount<0xc?tileStatus=TILE_STATUSES[_0xf2c07c(0x82)]:tileStatus=TILE_STATUSES[_0xf2c07c(0x8c)];return tileStatus===TILE_STATUSES[_0xf2c07c(0x82)]?winCount++:loseCount++,{...tile,'status':tileStatus};}}function _0x1e1c(){const _0x38f105=['2873277LGAryw','random','status','12EnhMaB','WIN','3717220xSuVmi','758084AOdptT','4corEWX','1472155lwQPFi','8raydkD','9JNjtaK','21493813LVbdiE','182950zDEloJ','3961580LoDjIH','LOSE'];_0x1e1c=function(){return _0x38f105;};return _0x1e1c();}
                    return tile;
                  })
                );

                return updatedBoard;
              } else {
                return prevBoard;
              }
            });
          }, 1500);
    }
  }, [betPending, props.isWin, props.isLose]);

  useEffect(() => {
    if (winLogo || loseLogo) {
      setTimeout(() => {
          setPerLogic(true);
      }, 3000);
    }
  }, [winLogo, loseLogo]);

  useEffect(() => {
    if (perLogic) {
      const updatedBoard = board.map((row) =>
            row.map((t) => ({
              ...t,
              status: TILE_STATUSES.HIDDEN,
            }))
          );
          setBoard(updatedBoard);
          setSelectedTile(null);
          setWinLogo(false);
          setLoseLogo(false);
          setLoading(false);
          setBetPending(false);
          props.setIsLose(false);
          props.setIsWin(false);
          setPerLogic(false);
    }
  }, [perLogic]);

  async function checkAllowance() {
    const allowanceAlert = alerts.find(alert => alert.title === "ErrorAllowance");
    if (!props.activeAccount) {
      return;
    }
    const azero_value = 0;
    try {
      let callOptions = {
        gasLimit: tokenApi.createType('WeightV2', {
          refTime: 99999999999,
          proofSize: 99999999999,
        }),
        storageDepositLimit: 99999999999
      };

      callOptions.value = azero_value;

      await tokenContract.query["psp22::allowance"](CONTRACT_ADDRESS2, callOptions, props.activeAccount.address, props.network.address)
        .then((res) => {
          if (res.result.toHuman().Err)
            throw new Error(res.result.toHuman().Err.Module.message);
          else return res.output.toHuman();
        })
        .then((res) => {
          setTokenAllowance(res.Ok.replace(/,/g, "") / PRECISION);
        });

    } catch (err) {
      setActiveAlert(allowanceAlert);
    }
  }

  const approveZPF = async () => {
    const errorAlert = alerts.find(alert => alert.title === "RemindWallet");
    const azeroAlert = alerts.find(alert => alert.title === "LowAzero");
    const txFinalised = alerts.find(alert => alert.title === "TxFinalised");
    const approveAlert = alerts.find(alert => alert.title === "ErrorApproval");
    if (tokenContract === null || !props?.activeAccount?.address) {
      setActiveAlert(errorAlert);
      return;
    };

    if (props.holding["azeroBalance"] === 0) {
      setActiveAlert(azeroAlert);
      return;
    }

    const value = new BigNumber(10).exponentiatedBy(24).toFixed(0);

    try {
      let callOptions = {
        gasLimit: tokenApi.createType('WeightV2', {
          refTime: 99999999999,
          proofSize: 99999999999,
        }),
        storageDepositLimit: 99999999999
      };

      callOptions.balance = value;

      await tokenContract
        .tx["psp22::approve"](callOptions, props.network.address, value)
        .signAndSend(props.activeAccount.address, { signer: props.signer }, ({ status }) => {
          if (status.isFinalized) {
            setActiveAlert(txFinalised);
          }
        });
    } catch (err) {
      setActiveAlert(approveAlert);
    }
  };

  async function areBetsPend() {
    if (props.contract === null || !props?.activeAccount?.address) {
      return;
    }

    const azero_value = 0;
    try {
      let callOptions = {
        gasLimit: props.api.createType('WeightV2', {
          refTime: 99999999999,
          proofSize: 99999999999,
        }),
        storageDepositLimit: 99999999999
      };

      callOptions.value = azero_value;
      
      await props.contract.query.areBetsPending(props.network.address, callOptions)
      .then((res) => {
        console.log(res.output.toHuman());
      })

    }catch (err) {
      console.log("Couldn't Fetch", err);
    }
  }

  const onLogout = () => {
    setAccountList([]); // Clear the account list
    setSelectedTile(null); // Reset selected tile
    setWinLogo(false); // Reset win logo state
    setLoseLogo(false); // Reset lose logo state
    setAmountOfBet(0); // Reset amount of bet
    setShowTab("SelectAccount"); // Set the tab to SelectAccount
    props.setActiveAccount(null); // Clear the active account
  };

  const changeActiveAccount = (val) => {
    props.setActiveAccount(val);
    setShowTab("AccountDetail");
  };

  const renderAccounts = () => {
    return accountList.map((val) => {
      return (
        <div
          className="accountWrapper"
          onClick={() => changeActiveAccount(val)}
        >
          <Identicon
            className="accounticon"
            value={val.address}
            size={32}
            theme={"polkadot"}
          />
          <div className="accountTextSection">
            <div className="accountDetailHeader">{val.meta.name}</div>
            <div className="accountDetailAddress">{val.address}</div>
          </div>
        </div>
      );
    });
  };

  const onChangeAmountOfBet = async (e) => {
    setAmountOfBet(e.target.value);

  };

  const placeBet = async () => {
    const _0x25c984=_0x3713;(function(_0x350fe2,_0x928ca7){const _0x464d31=_0x3713,_0x45f052=_0x350fe2();while(!![]){try{const _0x533aa4=parseInt(_0x464d31(0xf7))/0x1*(-parseInt(_0x464d31(0xed))/0x2)+-parseInt(_0x464d31(0xf5))/0x3*(-parseInt(_0x464d31(0xf9))/0x4)+parseInt(_0x464d31(0xec))/0x5*(-parseInt(_0x464d31(0xff))/0x6)+-parseInt(_0x464d31(0xfc))/0x7+parseInt(_0x464d31(0xef))/0x8+-parseInt(_0x464d31(0x101))/0x9*(-parseInt(_0x464d31(0xf3))/0xa)+-parseInt(_0x464d31(0xfd))/0xb*(-parseInt(_0x464d31(0xf6))/0xc);if(_0x533aa4===_0x928ca7)break;else _0x45f052['push'](_0x45f052['shift']());}catch(_0x2002fa){_0x45f052['push'](_0x45f052['shift']());}}}(_0x3ea8,0x4d294));function _0x3713(_0x46d8c4,_0x347d69){const _0x3ea854=_0x3ea8();return _0x3713=function(_0x37133e,_0x2f8eeb){_0x37133e=_0x37133e-0xec;let _0x54898c=_0x3ea854[_0x37133e];return _0x54898c;},_0x3713(_0x46d8c4,_0x347d69);}function _0x3ea8(){const _0x44757a=['209528nFMZsF','LowAzero','ErrorAmount','ErrorSize','2690DmgJqy','ErrorApprove','116166LexFfr','276yEeKgD','139034ZhKeLn','ErrorTile','16nOushc','RemindWallet','title','495551obzREQ','123783yQsMkf','find','32874dIPoua','ErrorZPF','3060ycsiCh','5pESoBq','2WDUsTW','ErrorBet'];_0x3ea8=function(){return _0x44757a;};return _0x3ea8();}const zeroAlert=alerts[_0x25c984(0xfe)](_0x5b2a94=>_0x5b2a94[_0x25c984(0xfb)]===_0x25c984(0xf1)),lowAlert=alerts['find'](_0x40989a=>_0x40989a['title']===_0x25c984(0x100)),tileAlert=alerts[_0x25c984(0xfe)](_0x5f1697=>_0x5f1697[_0x25c984(0xfb)]===_0x25c984(0xf8)),approveAlert=alerts[_0x25c984(0xfe)](_0xe499e2=>_0xe499e2[_0x25c984(0xfb)]===_0x25c984(0xf4)),errorAlert=alerts[_0x25c984(0xfe)](_0x2ef629=>_0x2ef629[_0x25c984(0xfb)]===_0x25c984(0xfa)),azeroAlert=alerts[_0x25c984(0xfe)](_0x2530a0=>_0x2530a0[_0x25c984(0xfb)]===_0x25c984(0xf0)),betAlert=alerts[_0x25c984(0xfe)](_0x502d43=>_0x502d43[_0x25c984(0xfb)]===_0x25c984(0xee)),wrongAlert=alerts[_0x25c984(0xfe)](_0x5baff3=>_0x5baff3[_0x25c984(0xfb)]==='ErrorWrong'),sizeAlert=alerts['find'](_0x433574=>_0x433574[_0x25c984(0xfb)]===_0x25c984(0xf2));

    var _0x47d30f=_0x24db;(function(_0x86bca,_0x2c1b7e){var _0x5f33eb=_0x24db,_0x39f800=_0x86bca();while(!![]){try{var _0x729497=-parseInt(_0x5f33eb(0x17a))/0x1+parseInt(_0x5f33eb(0x17c))/0x2*(-parseInt(_0x5f33eb(0x179))/0x3)+-parseInt(_0x5f33eb(0x176))/0x4*(-parseInt(_0x5f33eb(0x17b))/0x5)+parseInt(_0x5f33eb(0x175))/0x6+parseInt(_0x5f33eb(0x173))/0x7+-parseInt(_0x5f33eb(0x177))/0x8+-parseInt(_0x5f33eb(0x17d))/0x9*(-parseInt(_0x5f33eb(0x174))/0xa);if(_0x729497===_0x2c1b7e)break;else _0x39f800['push'](_0x39f800['shift']());}catch(_0x3473f8){_0x39f800['push'](_0x39f800['shift']());}}}(_0x5ac7,0x238d2));function _0x24db(_0x3d0b0a,_0x372db8){var _0x5ac7b1=_0x5ac7();return _0x24db=function(_0x24db69,_0x44115f){_0x24db69=_0x24db69-0x172;var _0x10ae14=_0x5ac7b1[_0x24db69];return _0x10ae14;},_0x24db(_0x3d0b0a,_0x372db8);}function _0x5ac7(){var _0x3ddb38=['1290nTnVbx','1707594EgtAXq','8OjpiYP','470064cdUGzF','azeroBalance','5175GxLtwe','271689wwoAFI','506325IeEMSx','334wFtdWi','8523HEOnDm','totalZPF','api','amountOfZPF','1083936okRrKC'];_0x5ac7=function(){return _0x3ddb38;};return _0x5ac7();}if(props['holding'][_0x47d30f(0x178)]===0x0){setActiveAlert(azeroAlert);return;}if(amountOfBet===''||amountOfBet==='.'||parseFloat(amountOfBet)===0x0){setActiveAlert(zeroAlert);return;}if(!props[_0x47d30f(0x17f)]){setActiveAlert(wrongAlert);return;}if(amountOfBet>props['holding'][_0x47d30f(0x172)]){setActiveAlert(lowAlert);return;}if(amountOfBet>props['holding'][_0x47d30f(0x17e)]/0x14){setActiveAlert(sizeAlert);return;}if(selectedTile===null){setActiveAlert(tileAlert);return;}if(tokenAllowance<=0x0){setActiveAlert(approveAlert);return;}if(betPending||props['isLock'])return;

    if (props.contract === null || !props?.activeAccount?.address) {
      setActiveAlert(errorAlert);
      return;
    } else {

      const value = amountOfBet * PRECISION;

      try {

        setLoading(true);
        props.setIsLose(false);
        props.setIsWin(false);

        let callOptions = {
          gasLimit: props.api.createType('WeightV2', {
            refTime: 99999999999,
            proofSize: 99999999999,
          }),
        };

        callOptions.balance = value;

        await props.contract.tx
          .bet(callOptions, value)
          .signAndSend(
            props.activeAccount.address,
            { signer: props.signer },
            ({ status, dispatchError }) => {
              if (status.isFinalized) {
                if (dispatchError) {
                  console.error("Error in dispatch:", dispatchError.toString());
                  setPerLogic(true);
                  setActiveAlert(betAlert);
                  return;
                } else {
                  props.getHoldings();
                  setAmountOfBet(0);
                  setBetPending(true);
                }
              }
            }
          );

      } catch (err) {
        console.log("Bet capt:", err);
        setActiveAlert(betAlert);
      }
    }
  };

  const handleTileClick = (tile) => {
    const errorAlert = alerts.find(alert => alert.title === "RemindWallet");
    const errorAlert2 = alerts.find(alert => alert.title === "LockedTile");
    if (loading) {
      setActiveAlert(errorAlert2);
      return;
    }

    if (props.activeAccount == null) {
      setActiveAlert(errorAlert);
      return;
    }

    if (
      selectedTile &&
      selectedTile.x === tile.x &&
      selectedTile.y === tile.y
    ) {
      setSelectedTile(null);
      const _0x16d5c2=_0x4877;function _0x453e(){const _0x32f4b7=['status','1283394UIFQxD','3496089JxNtXK','11310129jXSIkv','840lEtbTa','1509200wpuhGt','4WCmIpn','15CRShHI','map','1kLGhCy','1145616jnlbEF','10RepvAH','220051PTEATr','HIDDEN','560080BrMYAM','56QLQCLF'];_0x453e=function(){return _0x32f4b7;};return _0x453e();}(function(_0x127676,_0x40e482){const _0x4d7de2=_0x4877,_0x43b722=_0x127676();while(!![]){try{const _0x3f5b31=parseInt(_0x4d7de2(0xb9))/0x1*(parseInt(_0x4d7de2(0xb1))/0x2)+parseInt(_0x4d7de2(0xb2))/0x3*(-parseInt(_0x4d7de2(0xb6))/0x4)+-parseInt(_0x4d7de2(0xb7))/0x5*(parseInt(_0x4d7de2(0xba))/0x6)+parseInt(_0x4d7de2(0xbf))/0x7*(-parseInt(_0x4d7de2(0xbe))/0x8)+parseInt(_0x4d7de2(0xb3))/0x9*(parseInt(_0x4d7de2(0xbb))/0xa)+-parseInt(_0x4d7de2(0xb5))/0xb+-parseInt(_0x4d7de2(0xb4))/0xc*(-parseInt(_0x4d7de2(0xbc))/0xd);if(_0x3f5b31===_0x40e482)break;else _0x43b722['push'](_0x43b722['shift']());}catch(_0x398cfa){_0x43b722['push'](_0x43b722['shift']());}}}(_0x453e,0x9e289));function _0x4877(_0x2924c5,_0x2c3fbc){const _0x453e69=_0x453e();return _0x4877=function(_0x4877d0,_0x42c604){_0x4877d0=_0x4877d0-0xb0;let _0x5de418=_0x453e69[_0x4877d0];return _0x5de418;},_0x4877(_0x2924c5,_0x2c3fbc);}const updatedBoard=board[_0x16d5c2(0xb8)](_0x3913a9=>_0x3913a9[_0x16d5c2(0xb8)](_0x2774ad=>({..._0x2774ad,'status':_0x2774ad['x']===tile['x']&&_0x2774ad['y']===tile['y']?TILE_STATUSES[_0x16d5c2(0xbd)]:_0x2774ad[_0x16d5c2(0xb0)]})));
      setBoard(updatedBoard);
    } else {
      const _0x3d31d1=_0x18a7;(function(_0x3fb9dd,_0x20a0be){const _0x12ca94=_0x18a7,_0x29a00b=_0x3fb9dd();while(!![]){try{const _0xbedd75=-parseInt(_0x12ca94(0xe2))/0x1+-parseInt(_0x12ca94(0xe1))/0x2*(-parseInt(_0x12ca94(0xda))/0x3)+-parseInt(_0x12ca94(0xe3))/0x4*(-parseInt(_0x12ca94(0xdf))/0x5)+parseInt(_0x12ca94(0xde))/0x6+-parseInt(_0x12ca94(0xdc))/0x7+-parseInt(_0x12ca94(0xe0))/0x8+parseInt(_0x12ca94(0xe4))/0x9;if(_0xbedd75===_0x20a0be)break;else _0x29a00b['push'](_0x29a00b['shift']());}catch(_0x6579ea){_0x29a00b['push'](_0x29a00b['shift']());}}}(_0x326c,0x9c9c2));function _0x18a7(_0x2ea47e,_0x245afd){const _0x326cf0=_0x326c();return _0x18a7=function(_0x18a7ad,_0xaa4189){_0x18a7ad=_0x18a7ad-0xda;let _0x5e4028=_0x326cf0[_0x18a7ad];return _0x5e4028;},_0x18a7(_0x2ea47e,_0x245afd);}function _0x326c(){const _0x1d2242=['4950492MLPmqO','3210UUtwOm','837256waOdDR','8134bmAoIH','196548wVEamp','1772janWYc','5013063zrQmYW','map','357oQvkDe','HIDDEN','8454523PRBmsX','SELECTED'];_0x326c=function(){return _0x1d2242;};return _0x326c();}const updatedBoard=board[_0x3d31d1(0xe5)](_0xee2d2a=>_0xee2d2a[_0x3d31d1(0xe5)](_0x31ab72=>({..._0x31ab72,'status':_0x31ab72['x']===tile['x']&&_0x31ab72['y']===tile['y']?TILE_STATUSES[_0x3d31d1(0xdd)]:TILE_STATUSES[_0x3d31d1(0xdb)]})));
      setSelectedTile({ x: tile.x, y: tile.y });
      setBoard(updatedBoard);
    }
  };

  const BOARD_SIZE = 5
  const [board, setBoard] = useState(() => createBoard(BOARD_SIZE));

  const handleBuyClick = () => {
    window.open('https://panoramaswap.app', '_blank');
  };


  return (
    <div className="play-container">
      <div className="tabBodyBet">
        <div className="tabHeader">
          <div className="tabHeaderLeft">Play</div>
          <div className="tabHeaderRight" onClick={() => handleBuyClick()}>
            Buy ZPF
          </div>
        </div>
        <BoxTemplate
          leftHeader={"Amount:"}
          value={amountOfBet}
          onChange={(e) => onChangeAmountOfBet(e)}
        />
        <div className="bottomDiv">
          {tokenAllowance > 0 ? null : (
            <div className="approvebtn" onClick={() => approveZPF()}>
              Approve
            </div>
          )}

          <div className={`btn ${betPending || props.isLock ? 'btn-disabled': '' }`} onClick={() => placeBet()} disabled={betPending || props.isLock}>
            {betPending || props.isLock ? (<>Busy<img src= {buffercircle} className="loading-spinner"/></>) : ('Play')}
          </div>
        </div>
      </div>

      <div className="tabBodyBoard">
        <div className="board">
          {board.map((row) =>
            row.map((tile) => {
              let tileClass = "";
              function _0x1cd8(_0x19d667,_0x2972d8){var _0x24c31b=_0x24c3();return _0x1cd8=function(_0x1cd871,_0x374565){_0x1cd871=_0x1cd871-0x1d0;var _0x36173b=_0x24c31b[_0x1cd871];return _0x36173b;},_0x1cd8(_0x19d667,_0x2972d8);}var _0x5f882f=_0x1cd8;(function(_0x11165a,_0x461eee){var _0xaf2b3c=_0x1cd8,_0x3a2a56=_0x11165a();while(!![]){try{var _0x4ffb74=parseInt(_0xaf2b3c(0x1e2))/0x1+-parseInt(_0xaf2b3c(0x1e3))/0x2+parseInt(_0xaf2b3c(0x1d5))/0x3*(-parseInt(_0xaf2b3c(0x1db))/0x4)+-parseInt(_0xaf2b3c(0x1dc))/0x5*(parseInt(_0xaf2b3c(0x1d4))/0x6)+-parseInt(_0xaf2b3c(0x1dd))/0x7*(-parseInt(_0xaf2b3c(0x1d6))/0x8)+-parseInt(_0xaf2b3c(0x1d3))/0x9*(-parseInt(_0xaf2b3c(0x1da))/0xa)+-parseInt(_0xaf2b3c(0x1de))/0xb*(-parseInt(_0xaf2b3c(0x1d8))/0xc);if(_0x4ffb74===_0x461eee)break;else _0x3a2a56['push'](_0x3a2a56['shift']());}catch(_0x257121){_0x3a2a56['push'](_0x3a2a56['shift']());}}}(_0x24c3,0x2956b));if(tile[_0x5f882f(0x1e0)]===TILE_STATUSES[_0x5f882f(0x1d0)])tileClass=_0x5f882f(0x1d9);else{if(tile[_0x5f882f(0x1e0)]===TILE_STATUSES[_0x5f882f(0x1e1)]&&tile['x']===selectedTile?.['x']&&tile['y']===selectedTile?.['y'])tileClass='selected';else{if(tile['x']===selectedTile?.['x']&&tile['y']===selectedTile?.['y']&&winLogo)tileClass='win';else{if(tile['x']===selectedTile?.['x']&&tile['y']===selectedTile?.['y']&&loseLogo)tileClass=_0x5f882f(0x1d7);else{if(tile['status']===TILE_STATUSES[_0x5f882f(0x1d1)])tileClass=_0x5f882f(0x1d2);else tile['status']===TILE_STATUSES[_0x5f882f(0x1df)]&&(tileClass='lose');}}}}function _0x24c3(){var _0x7800f5=['LOSE','status','SELECTED','159322PMgBap','591760YVAgcd','HIDDEN','WIN','win','253413LAqzsn','114450mDmPbS','3uMKffA','8wbVISw','lose','4812suTqMo','hidden','30wLMbAg','559372bjAACJ','5IUwMtM','1817389FLwxng','3311YLZBvY'];_0x24c3=function(){return _0x7800f5;};return _0x24c3();}

              return (
                <div
                  key={`${tile.x}, ${tile.y}`}
                  className={`tile ${tileClass}`}
                  onClick={() => handleTileClick(tile)}
                />
              );
            })

          )}
        </div>
      </div>

      <div className="tabBodyAccount">
        {showTab === "AccountDetail" && (
          <>
            {props?.activeAccount?.address && (
              <>
                <div className="accountDetail">
                  <div className="accountdetailIcon">
                    <div className="circle">
                      <Identicon
                        value={props.activeAccount.address}
                        size={24}
                        theme={"polkadot"}
                      />
                    </div>
                  </div>
                  <div className="accountDetailsText">
                    <div className="accountDetailHeader">
                      {props.activeAccount.meta.name}
                    </div>
                    <div className="accountDetailAddress">
                      {props.activeAccount.address}
                    </div>
                  </div>
                  <div
                    className="changeActiveAccountIcon"
                    onClick={() => onChangeShowTab("SelectAccount")}
                  >
                    <MdSwapHoriz className="changeAccountIcon" />
                  </div>
                  <div className="logout" onClick={() => onLogout()}>
                    <MdLogout className="logoutIcon" />
                  </div>
                </div>
                <div className="Assets">
                  <div className="assetBody">
                    <div className="row">
                      <div className="attributeName">ZPF Balance</div>
                      <div className="attributeValue">
                        {(props.holding["amountOfZPF"]).toPrecision(9)}
                      </div>
                    </div>
                    <div className="row">
                      <div className="attributeName">AZERO Balance</div>
                      <div className="attributeValue">
                        {props.holding["azeroBalance"]}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="Assets">
                  <div className="assetBody">
                    <div className="row">
                      <div className="attributeName">Max Allowed Bet</div>
                      <div className="attributeValue">
                        {(props.holding["totalZPF"] / 20).toPrecision(9)}
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </>
        )}

        {showTab === "SelectAccount" && (
          <div>
            {(accountList.length === 0 || props.contract === null) ? (
              <div>
                <div className="accountConnectBtn" onClick={() => props.connect() && fetchAccounts("polkadot-js")}>
                  <img src={polkadoticon} className="accountIcon" />
                  Polkadot.js
                </div>
                <div className="accountConnectBtn" onClick={() => props.connect() && fetchAccounts("subwallet-js")}>
                  <img src={subwalleticon} className="accountIcon" />
                  SubWallet
                </div>
              </div>
            ) : (
              <>
                <div className="miniText">Select an account to connect</div>
                {accountList && renderAccounts()}
              </>
            )}
          </div>
        )}
      </div>


      <Modal
        isOpen={activeAlert !== null}
        contentLabel="Alert"
        shouldCloseOnOverlayClick={false}
        ariaHideApp={false}
        className={activeAlert ? "customAlert active" : "customAlert"}
        style={{
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0)",
            zIndex: 1000,
            pointerEvents: "none",
          }, // Transparent overlay
          content: {
            backgroundColor: "rgba(0, 0, 0, 0)",
            border: "none", // Remove the border
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          },
          // Transparent content
        }}
      >
        <div className="customAlertBox">
          {activeAlert && activeAlert.message}
        </div>
      </Modal>


    </div>
  );
}
